import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

type SortGroupsType = 'sort_asc' | 'sort_desc';

export function sortGroups<TGroup extends SpGroupType>(
    type: SortGroupsType,
    groupA: TGroup,
    groupB: TGroup
) {
    if (type === 'sort_asc') {
        return groupA.name.localeCompare(groupB.name);
    }

    return groupB.name.localeCompare(groupA.name);
}
